
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/technologie",
      function () {
        return require("private-next-pages/[locale]/technologie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/technologie"])
      });
    }
  